<script>
  import { fly } from "svelte/transition";
  import { page } from "$app/stores";
  import { project, previewMode, previewFullHeightMode, postData } from "$lib/services/store";
  import Placeholder from "$lib/admin/components/blocks/helpers/Placeholder.svelte";
  import Nav from "$lib/main/Nav/index.svelte";
  import Breadcrumbs from "$lib/main/components/Breadcrumbs.svelte";
  import Icons from "$lib/main/components/Icons.svelte";
  import { isTournamentsRoute } from "$lib/services/utils";
  import imports from "$lib/admin/components/blocks/Importer.js";
  import { afterUpdate, onMount } from "svelte";

  export let post = null;
  export let docMode = false;
  export let session = null;

  const tournamentRoute = $project.settings.tournamentsUrl ?? "turneringar";

  let hoverIndex;
  let hoverOffsetTop;

  afterUpdate(() => {
    if ($previewMode === true) {
      const allBlocks = document.querySelectorAll(".block");

      allBlocks.forEach((item, index) => {
        item.addEventListener("mouseenter", function (e) {
          hoverIndex = index;
          hoverOffsetTop = e.target.offsetTop;
        });
      });
    }
  });
  const isNewsArticleRoute = $page.url.pathname.includes("/nyheter/") && !/\/nyheter\/\d+$/.test($page.url.pathname);
</script>

<Nav project={$project} />
{#if isNewsArticleRoute}
  <Breadcrumbs />
{/if}
{#if $previewMode}
  <main class:sidebar={$project.settings?.sidebar}>
    <!-- svelte-ignore a11y-mouse-events-have-key-events -->
    <div
      id="preview-window"
      class="single-page"
      class:sidebar={$project.settings?.sidebar}
      class:full-height={$previewFullHeightMode === true}>
      {#if post}
        {#each post.content as block, index}
          {#if imports[block.blockType]?.cls}
            <svelte:component this={imports[block.blockType].cls} bind:props={block.props} adminView={false} />
          {:else}
            <svelte:component this={Placeholder} props={{ content: "Could not find or render this component.." }} />
          {/if}
        {/each}
      {/if}
    </div>
  </main>
{:else}
  <div
    class="single-page"
    class:dark-mode={isTournamentsRoute($page.url.pathname, tournamentRoute)}
    class:sidebar={$project.settings?.sidebar}>
    {#if post?.content}
      {#each post.content as block}
        {#if imports[block.blockType]?.cls}
          <svelte:component
            this={imports[block.blockType].cls}
            bind:props={block.props}
            adminView={false}
            hasContainer={true} />
        {/if}
      {/each}
    {/if}
  </div>
{/if}
